import { connect } from "react-redux";
import { BookingFlowComponent } from "./BookingFlowComponent";
import { bookingConfirmationReset, bookingConfirmationPayment } from "../../store/actions/bookingConfirmation";
import { bookingProcessReset } from "../../store/actions/bookingProcess";

const mapStateToProps = (state) => {
    const store = state.storeReducer.stores[state.storeReducer.storeIdSelected];
    let storeName = '';
    if (store) {
        storeName = store.storeName;
    }
    return ({
        currentStep: state.bookingConfirmationReducer.currentStep,
        stripeInstance: state.bookingConfirmationReducer.stripeInstance,
        setupClientSecret: state.bookingConfirmationReducer.setupClientSecret,
        isSubmittingCard: state.bookingConfirmationReducer.isSubmittingCard,
        paymentRequiredAmount: state.bookingConfirmationReducer.paymentRequiredAmount,
        bookingReferenceCode: state.bookingConfirmationReducer.bookingReferenceCode,
        errorText: state.bookingConfirmationReducer.errorText,
        restaurantName: storeName,
        date: state.bookingProcessReducer.dateSelected,
        time: state.bookingProcessReducer.timeSelected,
        people: state.bookingProcessReducer.numberOfPeople,
        translations: state.settingsReducer.translations,
        fatalErrorMessage: state.bookingConfirmationReducer.fatalErrorMessage,
    });
};


const mapDispatchToProps = dispatch => ({
    bookingConfirmationReset: () => dispatch(bookingConfirmationReset()),
    bookingConfirmationPayment: (stripe, card) => dispatch(bookingConfirmationPayment(stripe, card)),
    bookingProcessReset: () => dispatch(bookingProcessReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BookingFlowComponent);


// WEBPACK FOOTER //
// ./src/containers/BookingFlow/index.js